export const BILL_OF_LADING = 'bill_of_lading.gif';
export const BILL_OF_LADING_PDF = 'bill_of_lading.pdf';

// To extend file upload for non standard mime types
export const EXTENSION_BASED_MIMETYPES = {
  msg: 'application/vnd.ms-outlook',
};
